export default {
  EXERCISE_BENCHMARK_OPEN_PREVIEW_DIALOG: 'EXERCISE_BENCHMARK_OPEN_PREVIEW_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_PREVIEW_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_PREVIEW_DIALOG',
  EXERCISE_BENCHMARK_OPEN_PREVIEW_SINGLE_DIALOG: 'EXERCISE_BENCHMARK_OPEN_PREVIEW_SINGLE_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_PREVIEW_SINGLE_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_PREVIEW_SINGLE_DIALOG',
  EXERCISE_BENCHMARK_OPEN_CREATE_DIALOG: 'EXERCISE_BENCHMARK_OPEN_CREATE_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_CREATE_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_CREATE_DIALOG',
  EXERCISE_BENCHMARK_OPEN_CREATE_FROM_COPY_DIALOG: 'EXERCISE_BENCHMARK_OPEN_CREATE_FROM_COPY_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_CREATE_FROM_COPY_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_CREATE_FROM_COPY_DIALOG',
  EXERCISE_BENCHMARK_OPEN_EDIT_DIALOG: 'EXERCISE_BENCHMARK_OPEN_EDIT_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_EDIT_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_EDIT_DIALOG',
  EXERCISE_BENCHMARK_OPEN_EDIT_CONTRIBUTION_DIALOG: 'EXERCISE_BENCHMARK_OPEN_EDIT_CONTRIBUTION_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_EDIT_CONTRIBUTION_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_EDIT_CONTRIBUTION_DIALOG',
  EXERCISE_BENCHMARK_SET_BENCHMARKS: 'EXERCISE_BENCHMARK_SET_BENCHMARKS',
  EXERCISE_BENCHMARK_ADD_BENCHMARK: 'EXERCISE_BENCHMARK_ADD_BENCHMARK',
  EXERCISE_BENCHMARK_EDIT_BENCHMARK: 'EXERCISE_BENCHMARK_EDIT_BENCHMARK',
  EXERCISE_BENCHMARK_DELETE_BENCHMARK: 'EXERCISE_BENCHMARK_DELETE_BENCHMARK',
  EXERCISE_BENCHMARK_OPEN_CONTRIBUTE_DIALOG: 'EXERCISE_BENCHMARK_OPEN_CONTRIBUTE_DIALOG',
  EXERCISE_BENCHMARK_CLOSE_CONTRIBUTE_DIALOG: 'EXERCISE_BENCHMARK_CLOSE_CONTRIBUTE_DIALOG',
  EXERCISE_BENCHMARK_ADD_TO_CURRENT_BENCHMARKS: 'EXERCISE_BENCHMARK_ADD_TO_CURRENT_BENCHMARKS',
  EXERCISE_BENCHMARK_REMOVE_FROM_CURRENT_BENCHMARKS: 'EXERCISE_BENCHMARK_REMOVE_FROM_CURRENT_BENCHMARKS',
}